/* @flow strict */

import {
  RoutesType
} from 'client/src/routes';
import EventPage from './index';
import EventPageDetail from './detail';
import CreateEvent from './detail/createEdit/create/new';

export const EventRoutes: RoutesType = [
  {
    Component: CreateEvent,
    params: {
      exact: true,
      path: '/events/new/:eventId?/:viewTab?'
    }
  },
  {
    Component: EventPageDetail,
    params: {
      path: '/events/:eventId/:viewTab/:subViewTab?/:tableTab?'
    }
  },
  {
    Component: EventPage,
    params: {
      exact: true,
      path: '/events'
    }
  }
];
